import {FormWrapper} from "../../../../components/form-wrapper";
import {ProfileForm} from "../form";

export function UserProfileFormPage() {
  return (
    <FormWrapper>
      <ProfileForm />
    </FormWrapper>
  );
}
